import {Network} from "./Network"

export class LevelService {
    static findBySlug (slug) {
        return Network.fetch(true, `/level/${slug}`)
    }
}
